import React from 'lib/react';
import {
  EVGrid, EVTypography, EVCheckbox, makeStyles,
} from 'lib/components';
import { useTranslation } from 'lib/translation';
import PropTypes from 'prop-types';
import { useSelector, useDispatch } from 'lib/redux';
import { getPropertyValues } from 'features/orderPreferences/OrderPreferences.utils';
import { updateInputFieldValue } from 'features/orderPreferences/OrderPreferences.actions';
import ProductSubstitutionRadio from './ProductSubstitutionOptions.component';

const useStyles = makeStyles((theme) => ({
  productsAndDeliveryElements: {
    display: 'flex',
    flexDirection: 'column',
    width: '100%',
    height: 'fit-content',
    gap: '8px',
  },
  productsAndDeliveryElementsTop: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
    width: '100%',
    height: 'fit-content',
    gap: '8px',
    '@media(min-width: 834px)': {
      flexDirection: 'row',
    },
  },
  productsAndDeliveryElementsBottom: {
    display: 'flex',
    flexDirection: 'row',
    width: '100%',
    height: 'fit-content',
    gap: '8px',
  },
  productsAndDeliveryTitle: {
    color: theme.evPalette.charcoal[900],
    fontFamily: 'Noto Sans',
    fontWeight: 400,
    fontSize: '16px',
    lineHeight: '24px',
    fontStyle: 'normal',
  },
  productSubstitutionsHeaderDesc: {
    color: theme.evPalette.charcoal[800],
    fontFamily: 'Noto Sans',
    fontWeight: 400,
    fontSize: '14px',
    lineHeight: '18px',
    fontStyle: 'normal',
    margin: 'auto 0px',
  },
  checkChanges: {
    padding: '0px',
  },
}));

function ProductSubstitutionQuestion(props) {
  const classes = useStyles();
  const { t } = useTranslation();
  const dispatch = useDispatch();

  const { propertyName } = props;

  const orderPreferences = useSelector(({ userData }) => userData.orderPreferences);
  const inputFieldValues = useSelector(({ orderPreference }) => orderPreference.inputFieldValues);
  const { isAdmin } = orderPreferences;

  const {
    visible,
    canEdit,
  } = orderPreferences[propertyName] || {};

  const { allowSubAccounts } = getPropertyValues(orderPreferences, inputFieldValues, propertyName);

  const handleAllowSubAccountChange = ({ target: { checked } }) => dispatch(updateInputFieldValue(propertyName, 'allowSubAccounts', checked));

  if (!visible) return null;

  return (
    <EVGrid className={classes.productsAndDeliveryElements}>
      <EVGrid className={classes.productsAndDeliveryElementsTop}>
        <EVTypography className={classes.productsAndDeliveryTitle}>{t(`order_preferences__product_substitutions_question_${propertyName}`)}</EVTypography>
        <ProductSubstitutionRadio propertyName={propertyName} />
      </EVGrid>
      {isAdmin && (
        <EVGrid className={classes.productsAndDeliveryElementsBottom}>
          <EVCheckbox
            id={`CB-${propertyName}`}
            checked={allowSubAccounts}
            disabled={!canEdit}
            onChange={handleAllowSubAccountChange}
            color="primary"
            className={classes.checkChanges}
          />
          <label className={classes.productSubstitutionsHeaderDesc} htmlFor={`CB-${propertyName}`}>
            {t(`order_preferences__product_substitutions_CB_${propertyName}`)}
          </label>
        </EVGrid>
      )}
    </EVGrid>
  );
}

ProductSubstitutionQuestion.propTypes = {
  propertyName: PropTypes.string.isRequired,
};

export default ProductSubstitutionQuestion;
